import { useEffect, useRef } from 'react';

export default function ConceptSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.animate-target').forEach((el, i) => {
              setTimeout(() => {
                (el as HTMLElement).style.opacity = '1';
                (el as HTMLElement).style.transform = 'translateY(0)';
              }, i * 160);
            });
          }
        });
      },
      { threshold: 0.15 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="conceito"
      ref={sectionRef}
      className="bg-cream py-28 md:py-36 px-6 relative overflow-hidden"
    >
      {/* Decorative background element */}
      <div className="absolute top-0 right-0 w-72 h-72 opacity-5 pointer-events-none">
        <img
          src="https://public.readdy.ai/ai/img_res/43ee1e6684dd77b645d11cb87d132d0c.jpg"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>

      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          {/* Left: Image */}
          <div className="animate-target opacity-0 transition-all duration-700" style={{ transform: 'translateY(30px)' }}>
            <div className="relative">
              <div className="absolute -top-4 -left-4 w-full h-full border border-gold/30 hidden md:block" />
              <div className="w-full h-[300px] md:h-[480px] overflow-hidden">
                <img
                  src="https://storage.readdy-site.link/project_files/95ab1d24-f5e3-49af-acf5-f9d2f5689cc7/664cadaa-32f1-4087-ac13-642d79d24497_Screen-Shot-2026-03-26-at-10.34.16-AM.png?v=afb5a557ed2f3a6d5a65b6bab577dcf3"
                  alt="Mulheres executivas em imersão"
                  className="w-full h-full object-cover"
                  style={{ objectPosition: '50% 20%' }}
                />
              </div>
            </div>
          </div>

          {/* Right: Text */}
          <div>
            {/* Tag */}
            <div className="animate-target opacity-0 transition-all duration-700 mb-6" style={{ transform: 'translateY(30px)' }}>
              <span className="font-sans text-xs tracking-widest3 uppercase text-gold" style={{ letterSpacing: '0.3em' }}>
                O Conceito
              </span>
              <div className="w-12 h-px bg-gold mt-3" />
            </div>

            {/* Title */}
            <div className="animate-target opacity-0 transition-all duration-700 mb-8" style={{ transform: 'translateY(30px)' }}>
              <h2 className="font-serif text-4xl md:text-5xl font-bold text-obsidian leading-tight">
                Isto não é um evento.
                <br />
                <span className="italic text-gold">É uma convocação.</span>
              </h2>
            </div>

            {/* Gold divider */}
            <div className="animate-target opacity-0 transition-all duration-700 w-16 h-px bg-gold mb-8" style={{ transform: 'translateY(30px)' }} />

            {/* Text paragraphs */}
            <div className="animate-target opacity-0 transition-all duration-700 space-y-5" style={{ transform: 'translateY(30px)' }}>
              <p className="font-sans text-sm md:text-base text-obsidian/70 leading-relaxed font-light">
                Uma imersão de alto nível que reúne mulheres que não pedem permissão para ocupar o topo — elas constroem o caminho.
              </p>
              <p className="font-sans text-sm md:text-base text-obsidian/70 leading-relaxed font-light">
                Na natureza, são as leoas que caçam, protegem e lideram. O leão ruge para marcar território. A leoa ruge para conquistá-lo.
              </p>
              <p className="font-sans text-sm md:text-base text-obsidian/70 leading-relaxed font-light">
                Este não é um painel motivacional. É uma experiência curada para mulheres que executam — e querem estar ao lado de outras que fazem o mesmo.
              </p>
            </div>

            {/* Wine accent quote */}
            <div className="animate-target opacity-0 transition-all duration-700 mt-10 border-l-2 border-gold pl-6" style={{ transform: 'translateY(30px)' }}>
              <p className="font-serif italic text-gold text-base md:text-lg leading-relaxed">
                "Cada cadeira nesta sala carrega o peso de uma decisão, de uma empresa, de um time que depende de você."
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
